interface IconProps {
  className?: string;
}

const ImageIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.96596 6C5.58411 6 5.14453 6.35906 5.14453 6.96875V12.8025L7.78289 9.27263C7.81155 9.23429 7.84292 9.19806 7.87677 9.16421C8.85308 8.1879 10.436 8.1879 11.4123 9.16421C11.4331 9.18499 11.4529 9.20667 11.4718 9.22919L15.0428 13.4924L16.1268 12.4142L16.1279 12.413C17.1043 11.4379 18.6864 11.4383 19.6623 12.4142C19.6864 12.4383 19.7092 12.4636 19.7307 12.49L20.1445 12.9983V6.96875C20.1445 6.35906 19.705 6 19.3231 6H5.96596ZM22.1445 6.96875C22.1445 5.40382 20.9531 4 19.3231 4H5.96596C4.33591 4 3.14453 5.40382 3.14453 6.96875V18C3.14453 19.1046 4.03996 20 5.14453 20H20.1445C21.2491 20 22.1445 19.1046 22.1445 18V6.96875ZM20.1445 16.1662L18.2205 13.8029C18.0241 13.6336 17.7273 13.6421 17.541 13.8284L17.5391 13.8303L15.6808 15.6785C15.4823 15.876 15.21 15.9812 14.9302 15.9685C14.6505 15.9558 14.3889 15.8263 14.209 15.6117L9.97444 10.5562C9.79126 10.3951 9.51836 10.3907 9.33028 10.543L5.14453 16.1431V17.0312C5.14453 17.6409 5.58411 18 5.96596 18H19.3231C19.705 18 20.1445 17.6409 20.1445 17.0312V16.1662Z"
        fill="currentColor"
      />
      <path
        d="M15.6445 10.5C16.4725 10.5 17.1445 9.8295 17.1445 9C17.1445 8.172 16.4725 7.5 15.6445 7.5C14.8165 7.5 14.1445 8.172 14.1445 9C14.1445 9.8295 14.8165 10.5 15.6445 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ImageIcon;
